/**
 * Opens the rear camera for barcode/QR scanning. Call it straight from a tap handler:
 * iOS rejects permission prompts that don't come from a user gesture.
 */
export async function openScanCamera(): Promise<{ stream: MediaStream | null; error?: string }> {
  if (!navigator.mediaDevices?.getUserMedia) {
    return { stream: null, error: "This browser cannot access a camera. Open CliqSuite in Safari, Chrome, Edge or Firefox over HTTPS." };
  }
  try {
    const stream = await navigator.mediaDevices.getUserMedia({
      video: { facingMode: { ideal: "environment" }, width: { ideal: 1280 }, height: { ideal: 720 } },
      audio: false,
    });
    return { stream };
  } catch (cause) {
    const denied = cause instanceof DOMException && (cause.name === "NotAllowedError" || cause.name === "SecurityError");
    return { stream: null, error: denied ? "Camera access is blocked. Allow camera access in browser settings, then try again." : "The camera could not start. Close other apps using it and try again." };
  }
}
